import styled from 'styled-components'

export const ContainerDependencies = styled.div``

export const TextHeader = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  p {
    font-size: 16px;
    font-weight: 400;
  }
`

